import Checklists from 'assets/icons/fa/clipboard-list.svg'

export default Checklists
